import ExcelJS from 'exceljs/dist/exceljs.bare';
import { CellFormat, CumulativeData, TabConfig } from '../excel.service.model';
import { Product } from '../../../product-center-table-wrapper/product-center-table-wrapper.model';
import { Constants } from '../excel-service.constants';
import { formatDate } from '../excel-service.utils';
import { i18nService } from '../../../../common/i18n/i18n';

/**
 * Returns the configuration object for the Tile view.
 * @param getCumulativeWorksheetName A function to get the cumulative worksheet name.
 * @param formatDate A function to format dates.
 * @returns The configuration object for the Tile view.
 */
export async function getTileConfig(
  getCumulativeWorksheetName: () => string,
  language: string,
): Promise<TabConfig> {
  if (!i18nService.isI18nLoadedForLanguage(language)) {
    await new Promise((resolve) => {
      i18nService.loadi18nForLanguage(language, resolve);
    });
  }

  const localize = i18nService.getFixedT(language, null, null);

  return {
    worksheetName: getCumulativeWorksheetName(),
    fileName: `${localize(Constants.TRANSLATION_KEYS.FILE_NAME.CUMULATIVE_PERFORMANCE)}.${Constants.EXCEL_FILE_EXTENSION}`,
    headers: [
      localize(Constants.TRANSLATION_KEYS.PRODUCT_RANGE),
      localize(Constants.TRANSLATION_KEYS.PRODUCT_NAME),
      localize(Constants.TRANSLATION_KEYS.CLASS),
      localize(Constants.TRANSLATION_KEYS.APIR),
      localize(Constants.TRANSLATION_KEYS.PERFORMANCE.INCEPTION_DATE),
      getCumulativeWorksheetName(),
    ],
    columnWidths: Object.values(Constants.COLUMN_WIDTHS.CUMULATIVE),
    getRowData: (product: Product, fundReturnData?: CumulativeData) => [
      product.productName.vehicleTypeName,
      product.productName.fundName,
      product.productName.shareClass,
      product.productName.apir,
      formatDate(product.performance?.inceptionDate),
      fundReturnData?.fundValue,
    ],
    getBenchmarkRowData: (fundReturnData: CumulativeData) => [
      Constants.ROW_CONTENT.EMPTY,
      localize(Constants.TRANSLATION_KEYS.ROW_CONTENT.BENCHMARK_NAME, {
        benchmarkName: fundReturnData.benchmarkName || Constants.HYPHEN,
      }),
      Constants.ROW_CONTENT.EMPTY,
      Constants.ROW_CONTENT.EMPTY,
      Constants.ROW_CONTENT.EMPTY,
      fundReturnData.benchmarkValue,
    ],
    cellFormatters: [{ index: 5, format: CellFormat.NUMBER }],
    specialFormatting: (row: ExcelJS.Row) => {
      const alignment =
        row.getCell(5).value === Constants.HYPHEN
          ? Constants.ALIGNMENT.HORIZONTAL.LEFT
          : Constants.ALIGNMENT.HORIZONTAL.RIGHT;
      row.getCell(5).alignment = { horizontal: alignment };
    },
    renderFooterDisclaimers: true,
  };
}
